import supabase from "@/services/supabaseClient";

export async function logAuthAttempt({
  email,
  status,
  errorMessage = null,
  attemptId = null,
  userAgent = "",
  ip = null,
  stage = null,
  currentPath = null,
  hasCode = null,
  hasTokenHash = null,
  hasHashTokens = null,
  details = null,
} = {}) {
  const cleanEmail = String(email || "").trim().toLowerCase();
  const cleanStatus = String(status || "").trim().toLowerCase();

  if (!cleanEmail || !cleanStatus) return null;

  const { data, error } = await supabase.rpc("log_auth_attempt", {
    p_email: cleanEmail,
    p_status: cleanStatus,
    p_error_message: errorMessage,
    p_attempt_id: attemptId,
    p_user_agent: String(userAgent || "").trim() || null,
    p_ip: ip,
    p_stage: String(stage || "").trim() || null,
    p_current_path: String(currentPath || "").trim() || null,
    p_has_code: typeof hasCode === "boolean" ? hasCode : null,
    p_has_token_hash: typeof hasTokenHash === "boolean" ? hasTokenHash : null,
    p_has_hash_tokens: typeof hasHashTokens === "boolean" ? hasHashTokens : null,
    p_details: details && typeof details === "object" ? details : null,
  });

  if (error) throw error;
  return data || null;
}
